import { Button } from "antd";
import React from "react";
import './AdnMergeButton.css'
import { MergeOutlined } from "@ant-design/icons";

const AdnAddButton = ({ handleClick, name, visible, style, loading }) => {
  return (
    <div justify="end" style={style}>
          <Button onClick={handleClick} type={'primary'} visible={visible} className="adn-primary-button" loading={loading}>
              <MergeOutlined />{name || 'Merge'}
      </Button>
    </div>
  );
};

export default AdnAddButton;
